import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bc5926b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Vote on ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { id: "account" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  selected: "",
  value: ""
}, "- select account -", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  id: "please-select"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "modal-overlay",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-bet-modal')))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
      }, [
        _createElementVNode("label", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", {
            style: _normalizeStyle({color: _ctx.teamColor})
          }, _toDisplayString(_ctx.teamName), 5)
        ]),
        _hoisted_4,
        _createElementVNode("select", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account) => {
            return (_openBlock(), _createElementBlock("option", {
              key: account.address,
              value: account.address
            }, _toDisplayString(account.short), 9, _hoisted_7))
          }), 128))
        ]),
        (!_ctx.isValidAddress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Please select an account "))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.amount) = $event)),
          placeholder: "0",
          step: "0.000001",
          min: "0.01",
          maxlength: "8"
        }, null, 512), [
          [_vModelText, _ctx.amount]
        ]),
        _hoisted_9,
        (!_ctx.confirmText)
          ? (_openBlock(), _createElementBlock("input", {
              key: 1,
              type: "submit",
              value: "Sign Transaction",
              style: _normalizeStyle({ 'background-color': _ctx.teamColor })
            }, null, 4))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.confirmText), 1))
      ], 32)
    ])
  ]))
}